import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ConfigService } from '@orion-platform/core';
import { environment } from '@orion/environment';
import { map, Observable, Subject } from 'rxjs';
import { Identity, IdentityDetails, ResponseWithCount } from '../models/common.model';

// TODO rework refactor
@Injectable({
  providedIn: 'root',
})
export class CommonService {
  private DataGridVisible = new Subject<boolean>();
  private isGridRefreshed = new Subject<boolean>();
  private isGridCollapsed = new Subject<unknown>();
  private isReloadRequired = new Subject<boolean>();
  private subSectionView = new Subject<null | number>();
  private uploadDocumentsFilterRefresh$ = new Subject<void>();

  isDataGridVisible!: boolean;

  private configService = inject(ConfigService);
  private http = inject(HttpClient);
  private apiUrl!: string;

  constructor() {
    this.apiUrl = this.configService.getSettings('apiBaseUrl') as string;
  }

  getRefreshGridValue(): Observable<boolean> {
    return this.isGridRefreshed.asObservable();
  }

  setRefreshGridValue(isRefreshed: boolean): void {
    this.isGridRefreshed.next(isRefreshed);
  }

  getCollapseGridValue(): Observable<unknown> {
    return this.isGridCollapsed.asObservable();
  }

  setCollapseGridValue(isCollapsed: boolean, rowId?: string): void {
    let data = {
      isCollapsed: isCollapsed,
      rowId: rowId,
    };
    this.isGridCollapsed.next(data);
  }

  getSubSectionView(): Observable<null | number> {
    return this.subSectionView.asObservable();
  }

  setSubSectionView(subSectionView: null | number): void {
    this.subSectionView.next(subSectionView);
  }

  getReloadRequired(): Observable<boolean> {
    return this.isReloadRequired.asObservable();
  }

  setReloadRequired(isReloadRequired: boolean): void {
    this.isReloadRequired.next(isReloadRequired);
  }

  emitUploadDocumentsFilterRefresh(): void {
    this.uploadDocumentsFilterRefresh$.next();
  }

  onUploadDocumentsFilterRefresh(): Observable<void> {
    return this.uploadDocumentsFilterRefresh$.asObservable();
  }

  getUTCDateStr(filter: Date | string): string {
    filter = new Date(filter);
    return `${filter.getFullYear()}-${filter.getMonth() + 1}-${filter.getDate()}T00:00:00.000Z`;
  }

  //NOTE - IdentityList API

  getApiUrlIdentityList(): string {
    return `${this.apiUrl}${environment.modulesBaseUrl.materialManagement.identityList}`;
  }

  getIdentityListForBuyers(
    type?: string,
  ): Observable<{ response: ResponseWithCount<Identity>; type: string }> {
    let params = new HttpParams();
    const identityType = type ? type : 'identity';

    params = params.append('identitytype', identityType);
    params = params.append('$orderby', 'firstname asc');

    return this.http
      .get<ResponseWithCount<Identity>>(this.getApiUrlIdentityList(), { params })
      .pipe(
        map(
          (
            apiResponse: ResponseWithCount<Identity>,
          ): { response: ResponseWithCount<Identity>; type: string } => ({
            response: apiResponse,
            type: identityType,
          }),
        ),
      );
  }

  mapIdentityData(identityData: Identity): IdentityDetails {
    let identityObj: Record<string, unknown> = {};
    if (identityData.contacts?.length) {
      for (const c of identityData.contacts) {
        if (c && c.contacttype) {
          identityObj[c.contacttype] = c.value;
        }
      }
    }

    // addresses of first object
    let addressObj: Record<string, unknown> = {};
    if (identityData?.addresses?.length && typeof identityData.addresses[0] === 'object') {
      const address = identityData.addresses[0];
      (Object.keys(address) as Array<keyof typeof address>).forEach((key): void => {
        addressObj[key as string] = address[key];
      });
    }

    // Create a shallow copy and remove contacts and addresses
    let result = Object.assign({}, identityData, identityObj, addressObj);
    delete result.contacts;
    delete result.addresses;

    return result;
  }
}
